module.exports = __webpack_public_path__ + "img/bubble_red_1.6c565431.png";